export const User = (props) => {
    return {
        ...props,
        channel: `App.User.${props.id}`,
        can: (permission) => props.permissions.indexOf(permission) >= 0,
        hasRole: (role) => props.roles.indexOf(role) >= 0
    }
};
